// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51068":"9dbcf153","52467":"c3aebb46","59981":"deb33415"}[chunkId] + ".chunk.css";
};